 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyStickyContainer = () => {
  return (
    <>
      <Breadcrumbs title="Property Details" url={routes.Home.PropertyDemo1} />
      <PropertyDetail type="sticky" mainClass="detail-sticky-section" />
    </>
  );
};

export default PropertyStickyContainer;
